module.exports = __webpack_public_path__ + "img/bottomBg1.192c3082.png";